import { ChanceResultDisplay } from "../../../../interfaces/services";

interface IVisaChancesSwitchProps {
    filter: ChanceResultDisplay;
    setFilter: (filter: ChanceResultDisplay) => void;
}

const VisaChancesSwitch = (props: IVisaChancesSwitchProps) => {
    const { filter, setFilter } = props;

    const handleFilterChange = (item: ChanceResultDisplay) => {
        setFilter(item);
    }

    const getSelectedClass = (item: ChanceResultDisplay) => {
        return filter === item ? 'immersion__visa_chances__switch__item immersion__visa_chances__switch__item_selected' : 'immersion__visa_chances__switch__item';
    }

    return (
        <div className='immersion__visa_chances__switch'>
            <button
                className={getSelectedClass(ChanceResultDisplay.GOOD)}
                onClick={() => handleFilterChange(ChanceResultDisplay.GOOD)}
            >
                <p>Good</p>
            </button>
            <button
                className={getSelectedClass(ChanceResultDisplay.BAD)}
                onClick={() => handleFilterChange(ChanceResultDisplay.BAD)}
            >
                <p>Bad</p>
            </button>
        </div>
    );
}

export default VisaChancesSwitch;